import 'src/styles/ui/select.css';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * @param {'sm'|'field'} props.variant - 'field' matches the Input component's
 *   rounded field look (forms); 'sm' keeps the legacy compact look.
 */
const Select = ({ name, value, onChange, children, disabled, variant }) => (
  <div
    className={`select ${variant === 'field' ? 'select--field' : 'select--sm'} ${
      disabled ? 'select--disabled' : ''
    }`}
  >
    <select name={name} value={value} className='select__input' onChange={onChange}>
      {children}
    </select>
    <FontAwesomeIcon icon={faChevronDown} className='select__icon' />
  </div>
);

Select.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['sm', 'field']),
};

Select.defaultProps = {
  disabled: false,
  variant: 'sm',
};

export default Select;
